import { render, staticRenderFns } from "./EditLiveRoleForm.vue?vue&type=template&id=1e4d4e87"
import script from "./EditLiveRoleForm.vue?vue&type=script&lang=js"
export * from "./EditLiveRoleForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports